import * as React from 'react';

export type Queue<T> = {
    queue: T[];
    enqueue: (item: T) => void;
    dequeue: () => void;
    resetQueue: () => void;
};

export const useQueue = <T>(initial: T[] = []): Queue<T> => {
    const [queue, setQueue] = React.useState<T[]>(initial);

    const enqueue = React.useCallback((item: T) => setQueue([...queue, item]), [queue]);

    const dequeue = React.useCallback(() => {
        if (queue.length === 0) {
            return;
        }

        setQueue(queue.slice(1));
    }, [queue]);

    const resetQueue = React.useCallback(() => {
        setQueue([]);
    }, []);

    return {
        queue,
        enqueue,
        dequeue,
        resetQueue,
    };
};
